import {defineSlotRecipe} from '@chakra-ui/react3'

const productAnimatedModuleRecipe = defineSlotRecipe({
    slots: ['container', 'stickyContainer', 'textBox', 'productBox', 'textContent'],
    base: {
        container: {
            px: {base: 0, s: 'spacing-90'},
            '--padding-bottom': {base: 0, s: 'spacing.spacing-128'},
            pb: 'var(--padding-bottom, 0px)'
        },
        stickyContainer: {
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center'
        },
        textBox: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        textContent: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-16',
            width: '100%'
        },
        productBox: {
            width: '100%',
            maxWidth: 'calc(100vh - var(--max-header-height, var(--header-height, 132px)))',
            aspectRatio: '1/1'
        }
    },
    variants: {
        layout: {
            'side-by-side': {
                container: {
                    '--padding-bottom': '0'
                },
                stickyContainer: {
                    flexDirection: {base: 'column', s: 'row'}
                },
                textBox: {
                    w: {base: '100%', s: '50%'},
                    alignItems: 'flex-start',
                    pt: {base: 'spacing-64', s: 'spacing-90'},
                    pr: {base: 'spacing-24', s: 'spacing-90'},
                    pb: {base: 'spacing-48', s: 'spacing-90'},
                    pl: {base: 'spacing-24', s: '0'}
                },
                textContent: {
                    maxWidth: {base: 'auto', s: 409},
                    textAlign: 'left'
                },
                productBox: {
                    w: {base: '100%', s: '50%'}
                }
            },
            'product-below-copy': {
                stickyContainer: {
                    flexDirection: 'column'
                },
                textBox: {
                    w: '100%',
                    alignItems: 'center',
                    pt: {base: 'spacing-64', s: 'spacing-128'},
                    pr: {base: 'spacing-24', s: '0'},
                    pb: {base: 'spacing-48', s: 'spacing-40'},
                    pl: {base: 'spacing-24', s: '0'}
                },
                textContent: {
                    maxWidth: {base: 'auto', s: 622},
                    textAlign: {base: 'left', s: 'center'}
                },
                productBox: {
                    w: {base: '100%', s: '630px'}
                }
            }
        }
    }
})

export default productAnimatedModuleRecipe
